/*@ngInject*/
const ManageUserFormViewerController = function ($scope, $stateParams) {

    $scope.viewModel = {
        formId: parseInt($stateParams.formId)
    };
};

angular.module('umCore')
    .controller('manageUserFormViewerController', ManageUserFormViewerController);
